// routes

import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import { LoadingProvider } from './contexts/LoadingContext';
import { CrmSettingsProvider } from './contexts/SettingContext';
import { useEffect } from 'react';

// import { useLoading } from 'src/contexts/LoadingContext';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <LoadingProvider>
      <CrmSettingsProvider>
        <ThemeConfig>
          <ScrollToTop />
          <GlobalStyles />
          <BaseOptionChartStyle />
          <Router />
        </ThemeConfig>
      </CrmSettingsProvider>
    </LoadingProvider>
  );
}
